import React, {Component} from 'react';

class Top extends Component {
    render(){
        return (
            <div 
                className="top"
                style={{
                    backgroundColor: "#E2BCAA",
                    height: "40px"
                }} 
            >
                
            </div>
        )
    }
}

export default Top;